import React from "react";
import "./descriptionRows.scss";
import Text from "../../atoms/text/text";

import "../../../styles/fontSizes.scss";

/* data= {
   title: "",
   characteristics: [
       title: "",
       description: ""
   ] 
}*/
const DescriptionRows = ({ dataDescription }) => {
  let tituloCarta =
    dataDescription.title.charAt(0).toUpperCase() +
    dataDescription.title.slice(1).toLowerCase();

  const data = {
    title: "INFORMACIÓN SOBRE EL PROGRAMA",
    characteristics: [
      {
        title: "Nivel de formación:",
        description:
          dataDescription.formationName + " - " + dataDescription.formationType,
      },
      {
        title: "Área curricular:",
        description: dataDescription.curricularArea,
      },
      { title: "Código SIA:", description: dataDescription.codeSIA },
      {
        title: "Nombre del programa curricular:",
        description: tituloCarta + " - La Paz",
      },
      {
        title: "Año de creación:",
        description: dataDescription.date.slice(0, 4),
      },
      { title: "Código SNIES:", description: dataDescription.codeSNIES },
      { title: "Título que otorga:", description: dataDescription.degree },
      { title: "Jornada:", description: dataDescription.schedule },
      { title: "Sede:", description: dataDescription.site },
      { title: "Metodología:", description: dataDescription.modality },
      { title: "Duración estimada:", description: dataDescription.duration },
      { title: "Créditos:", description: dataDescription.totalCredits },
    ],
  };
  return (
    <>
      <div className="font-size--1 description-r__container">
        <Text fontWeight={400} type={"h"} textSize={3}>
          {data.title}
        </Text>
        <div className="description-r__content">
          {data.characteristics.map((c, index) => (
            <div key={index}>
              <Text fontWeight={400} type={"h"} textSize={1}>
                {c.title}
              </Text>
              <Text fontWeight={100} type={"p"} textSize={1}>
                {c.description == "" ? "-" : c.description}
              </Text>
              <br />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DescriptionRows;
